import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { withRouter } from 'next/router';
import Head from 'next/head';
import getConfig from 'next/config';
import tracking from '@g4/g4-analytics';
import Cookies from 'universal-cookie';
import { AUTH_TOKEN_COOKIE } from '../WithApollo/authUtils';

import Layout from '@g4/boneyard/lib/Layout';
import VerticalSpacing from '@g4/boneyard/lib/VerticalSpacing';

import PrintAware from '../PrintAware';
import SiteHeader from '../SiteHeader';
import SiteFooter from '../SiteFooter';
import ScrollToTop from '../ScrollToTop';

const { Main, Content } = Layout;

// Because we want to apply a background color on the <body> we will inject it globally
// for this occasion we'll use a hardcoded value
// const GlobalStyles = createGlobalStyle`
//   body { background-color: #f4f5f6; }
// `;

const MainWrapper = styled.div`
  background-color: ${props =>
    props.invertedTheme ? props.theme.colors.hob.footer.bg : 'transparent;'};
  flex: 1 0 auto;
`;

export const AnalyticsContext = React.createContext();

const { publicRuntimeConfig = {} } = getConfig() || {};
const { buildVersion = 'development' } = publicRuntimeConfig;

class SiteLayout extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    router: PropTypes.any.isRequired,
    children: PropTypes.node,
    invertedTheme: PropTypes.bool,
    printable: PropTypes.bool,
    client: PropTypes.object,
  };

  static defaultProps = {
    printable: false,
  };

  componentDidMount() {
    const appVersion = getConfig()?.publicRuntimeConfig?.appVersion;
    const cookies = new Cookies(document && document.cookie);
    const searchManifest = 'transaction-id';
    const cid = cookies.cookies['_ga'];
    const isAuthenticated = cookies.cookies[AUTH_TOKEN_COOKIE];

    let dataLayerVariables = {
      customer_type: isAuthenticated ? 'Customer' : 'Guest',
      customer_id: cid,
      drupal_version: buildVersion,
      search_manifest: cookies.cookies[searchManifest],
      qualified_user: '1',
      software_version: appVersion,
      affiliation: 'WWW- HLO',
    };

    this.updateDataLayerVariables(dataLayerVariables);
  }

  updateDataLayerVariables(newDataLayerVariables) {
    tracking.setDataLayerVars(newDataLayerVariables);
  }

  render() {
    const { children, invertedTheme, printable } = this.props;

    return (
      <Layout>
        <ScrollToTop />
        <AnalyticsContext.Provider
          value={{
            updateValues: this.updateDataLayerVariables,
          }}
        >
          {/* <GlobalStyles /> */}
          <Head>
            <title>{this.props.title}</title>
          </Head>

          <PrintAware printable={printable}>
            <SiteHeader />
          </PrintAware>

          <MainWrapper invertedTheme={invertedTheme}>
            <Main>
              <Content>
                <div id="main">{children}</div>
              </Content>
            </Main>
          </MainWrapper>

          <VerticalSpacing size={4} />
          <PrintAware printable={printable}>
            <SiteFooter invertedTheme={invertedTheme} />
          </PrintAware>
        </AnalyticsContext.Provider>
      </Layout>
    );
  }
}

export default withRouter(withTheme(SiteLayout));
